import React from "react";
import closeGrayIcon from "@src/assets/svg/close-icon-gray.svg";
import thingsSupportIcon from "@src/assets/svg/things-support-blue.svg";
import { HelpIconPopover } from "@src/components/atoms/help-icon-popover/help-icon-popover";
import { useAddNewMachineDrawerModalContext } from "./add-new-machine-drawer-modal-context";
import styles from "./add-new-machine-drawer-modal.module.scss";

const cssClassName = "add-new-machine-drawer-modal";

export const VncSkillCard = () => {
  const {
    texts,
    machineSkillsTexts,
    isSupportExpanded,
    vncPort,
    showVncPortAvailable,
    setIsSupportExpanded,
    setVncPort,
  } = useAddNewMachineDrawerModalContext();

  return (
    <div className={styles["skill-card"]}>
      <div className={styles["skill-card-header"]}>
        <div className={styles["skill-card-header-left"]}>
          <img
            src={thingsSupportIcon}
            alt={machineSkillsTexts.thingsSupportTitle}
            className={styles["skill-card-icon"]}
          />
          <h4 className={styles["skill-card-title"]}>
            {machineSkillsTexts.thingsSupportTitle}
          </h4>
        </div>
        <button
          type="button"
          className={styles["toggle-skill-button"]}
          onClick={() => setIsSupportExpanded(!isSupportExpanded)}
        >
          <span className={styles["toggle-skill-button-symbol"]}>
            {isSupportExpanded ? "−" : "+"}
          </span>
        </button>
      </div>
      <div className={styles["skill-card-content"]}>
        <p className={styles["skill-card-description"]}>
          {machineSkillsTexts.thingsSupportDescription}
        </p>
      </div>

      {isSupportExpanded && (
        <div className={styles["skill-card-expanded-content"]}>
          <div className={styles[`${cssClassName}__input-container`]}>
            <div className={styles["skill-label-row"]}>
              <label className={styles[`${cssClassName}__label`]}>
                {machineSkillsTexts.vncPortLabel}
              </label>
              <span className={styles["skill-help-container"]}>
                <HelpIconPopover
                  helpLabel={texts.help}
                  helpText={machineSkillsTexts.vncPortHelpText}
                />
              </span>
            </div>
            <div className={styles[`${cssClassName}__input-wrapper`]}>
              <input
                type="text"
                value={vncPort}
                className={styles[`${cssClassName}__input`]}
                onChange={(e) => setVncPort(e.target.value)}
              />
              {vncPort && (
                <button
                  type="button"
                  className={styles["port-clear-button"]}
                  onClick={() => setVncPort("")}
                >
                  <img src={closeGrayIcon} alt="" />
                </button>
              )}
            </div>
            {showVncPortAvailable && (
              <p className={styles["port-available-text"]}>
                {machineSkillsTexts.portIsAvailableLabel}
              </p>
            )}
          </div>
        </div>
      )}
    </div>
  );
};
